import { callEndpoint, callEndpointWithPayload } from '../baseApi'

export const GetVirtualEvent = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/virtual_events/${uuid}`, 'GET', idToken)
}

export const UpdateVirtualEvent = async (uuid, idToken, payload) => {
  return await callEndpointWithPayload(`${process.env.REACT_APP_API}/virtual_events/${uuid}`, 'PATCH', idToken, payload)
}

export const DeleteVirtualEvent = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/virtual_events/${uuid}`, 'DELETE', idToken)
}
